import React from "react";
// import Header from "./Header.js";
// import Image from "./Image.js";
import ShopByCategory from "../HomePage/ShopByCategory";
// import LimitedTimeDeals from "../HomePage/LimitedTimeDeals";
import CommonHealthIssue from "./MedicineStore.js";

export default function MedicinePage() {
  return (
    <div className="w-full px-4 md:px-8 py-4">
      
      {/* <Header /> */}

      {/* <div className="mt-4">
        <Image />
      </div> */}

      <div className="mt-6">
        <CommonHealthIssue />
      </div>

      <div className="mt-6">
        <ShopByCategory />
      </div>

      {/* <div className="mt-6">
        <LimitedTimeDeals />
      </div> */}

    </div>
  );
}